import React from "react";

type Props = {};

const AddMedicationDesktop = (props: Props) => {
  return <div>AddMedicationDesktop</div>;
};

export default AddMedicationDesktop;
